// extracted by mini-css-extract-plugin
export default {"label":"TaskSelectStatus_label__u+qgS"};